(function($) {
	"use strict";

	/**
	 * Ce plugin crée un popin permettant de dessiner une signature
	 * 
	 * @param options.image | élément DOM d'une image à afficher sur le canvas à l'ouverture du popin. Aucune image par défaut
	 * @param options.lang
	 * @param options.execute | fonction qui prend en argument un dataUrl de l'image du canvas en paramètre et qui retourne une promise. Obligatoire. Le dataUrl peut être null si le canvas est vide
	 */
	$.fn.materialPopinSignature = function(options) {
		// Injection des options par défaut
		options = $.extend({}, $.fn.materialPopinSignature.defaultOptions, options);

		// Récupération de la langue
		var lang = $.fn.materialPopinSignature.langs[options.lang];

		var canvas = $('<canvas></canvas>').css({
			border: "2px solid #000000"
		});
		$(this).css('height', '100%').append(canvas);

		var drawing = false;
		var isEmpty = !options.image;

		function reset() {
			context.clearRect(0, 0, canvas.attr("width"), canvas.attr("height"));
			context.fillStyle = '#FFFFFF';
			context.fillRect(0, 0, canvas.attr("width"), canvas.attr("height"));
			isEmpty = true;
		}

		function startDraw(clientX, clientY) {
			isEmpty = false;
			drawing = true;
			var rect = canvas.get(0).getBoundingClientRect();
			var x = clientX - rect.left;
			var y = clientY - rect.top;
			context.beginPath();
			context.moveTo(x, y);
		}
		function draw(clientX, clientY) {
			if (drawing) {
				var rect = canvas.get(0).getBoundingClientRect();
				context.lineTo(clientX - rect.left, clientY - rect.top);
				context.stroke();
			}
		}
		function endDraw() {
			drawing = false;
		}

		var buttons = [];
		if (!options.readOnly) {
			canvas.on('mousedown', function(evt) {
				startDraw(evt.clientX, evt.clientY);
			});
			canvas.on('mousemove', function(evt) {
				draw(evt.clientX, evt.clientY);
			});
			canvas.on('mouseup', function(evt) {
				endDraw();
			});
			canvas.on('touchstart', function(evt) {
				if (evt.touches.length > 1)
					return;
				var touch = evt.changedTouches[0];
				startDraw(touch.clientX, touch.clientY);
			});
			canvas.on('touchmove', function(evt) {
				if (evt.touches.length > 1)
					return;
				var touch = evt.changedTouches[0];
				draw(touch.clientX, touch.clientY);
			});
			canvas.on('touchend', function(evt) {
				if (evt.touches.length > 0)
					return;
				endDraw();
			});
			buttons = [{
				icon : 'done',
				visible : true,
				title: lang['SendButton'],
				onclickPromise : function validate() {
					var data = isEmpty ? undefined : canvas[0].toDataURL(options.imageType);
					return options.execute(data);
				}
			},
			{
				icon : 'brush',
				visible : true,
				title: lang['ClearButton'],
				onclick : function validate() {
					reset();
				}
			}];
		}

		$(this).materialPopin({
			title: lang['Title'],
			closeButtonTitle: lang['CancelButton'],
			buttons : buttons
		});

		// Il faut que le popin soit déjà ouvert pour dimensionner le canvas
		var size = $(this).width() > $(this).height() ? $(this).height() : $(this).width();
		canvas.attr("width", size).attr("height", size);
		var context = canvas.get(0).getContext('2d');
		reset();
		if (options.image) {
			context.drawImage(options.image, 0, 0, size, size);
		}
	};

	/** Traduction des libellés utilisés dans les différentes langues supportées */
	$.fn.materialPopinSignature.langs = {
		fr: {
			Title: 'Signature',
			SendButton: 'Envoyer',
			CancelButton: 'Annuler',
			ClearButton: 'Effacer',
		},
		en: {
			Title: 'Signature',
			SendButton: 'Send',
			CancelButton: 'Cancel',
			ClearButton: 'Clear',
		},
		de: {
			Title: 'Unterschrift',
			SendButton: 'Absenden',
			CancelButton: 'Abbrechen',
			ClearButton: 'Abwischen',
		}
	};

	/** Options par défaut pour la construction du popin de mail */
	$.fn.materialPopinSignature.defaultOptions = {
		lang: 'fr',
		imageType: 'image/png',
		readOnly: false
	};

})(window.jQuery);